export const managerMisc = {
  // Shared field / label strings reused across the advisor and user views
  fields: {
    name: "Imię",
    lastname: "Nazwisko",
    email: "Adres e-mail",
    idNumber: "Numer dokumentu",
    phone: "Telefon",
  },
  // src/views/Manager/pagos/index.vue
  pagos: {
    title: "Faktury za płatności",
    subtitle: "Lista płatności dokonanych przez użytkowników",
    emailUser: "E-mail użytkownika",
    value: "Kwota",
    issueDate: "Data wystawienia",
    status: "Status",
    downloadInvoice: "Pobierz fakturę",
    generatingInvoice: "Generowanie faktury ...",
    almostDone: "Już prawie gotowe, proszę czekać ...",
    loading: "Wczytywanie ...",
    invoiceError: "Niestety nie udało się wygenerować faktury",
  },
  // src/views/Manager/advisors/* and src/components/manager/advisors/*
  advisors: {
    title: "Doradcy platformy",
    subtitle: "Lista doradców.",
    createNew: "Utwórz nowego",
    thId: "ID",
    thRefCode: "Kod ref.",
    thEmail: "E-mail",
    thRegisterDate: "Data rejestracji",
    deleteConfirmMsg: "Czy na pewno usunąć tego doradcę?",
    deleteConfirmHeader: "Potwierdź",
    menuUpdateInfo: "Zaktualizuj dane",
    menuAffiliatesList: "Lista poleconych",
    menuDelete: "Usuń",
    createTitle: "Utwórz nowego doradcę",
    savingInfo: "Zapisywanie danych...",
    saveAdvisor: "Zapisz doradcę",
    updateTitle: "Zaktualizuj dane doradcy",
    updatingInfo: "Aktualizowanie danych...",
    updateAdvisor: "Zaktualizuj doradcę",
    cancel: "Anuluj",
  },
  // src/components/manager/advisors/modalListAffiliates.vue
  affiliates: {
    listTitle: "Lista poleconych",
    emptyPre: "Żaden użytkownik nie jest powiązany z kodem",
  },
  // src/components/manager/users/menuRoutes.vue
  menu: {
    checkinsDone: "Zakończone check-in",
    checkinsPending: "Oczekujące check-in",
    checkinsScheduled: "Zaplanowane check-in",
    logoAndName: "Logo i nazwa obiektu",
    welcomeMessage: "Wiadomość powitalna",
    policies: "Regulamin obiektu",
    roomKeys: "Klucze do pokoi",
    authorities: "Służby",
    guestReviews: "Opinie gości",
  },
  // src/components/manager/users/accommodations.vue
  accommodations: {
    createdDate: "Data utworzenia",
    checkins: "Check-in",
  },
  // src/views/Manager/index.vue
  dashboard: {
    title: "Panel administratora",
    subtitle: "Lista statystyk platformy",
    registeredUsers: "Zarejestrowani użytkownicy",
    viewList: "Zobacz listę",
    propertiesCreated: "Utworzone obiekty",
    checkinsDone: "Zakończone check-in",
  },
};
